import { ItemListContainer, ItemWrapper, ItemInfoWrapper, ItemTitleWrapper, ColumnWrapper, ItemLeftWrapper, ItemActionsWrapper } from "./itemList.styled";
import { Typography, Icon, Button } from "@ann/web-components";



const NoteItem = ({ info, onOpen, onDelete, setShowNotesSlideOut }) => {
    const handleOpen = () => {
        if (onOpen) {
            onOpen(info);
        } else if (setShowNotesSlideOut) {
            setShowNotesSlideOut(true);
        }
    };

    const handleDelete = () => {
        if (onDelete) {
            onDelete(info);
        }
    };

    return (
        <ItemListContainer>
            <ItemWrapper>
                <ItemLeftWrapper>
                    <ItemTitleWrapper>
                        <Icon name='stickyNote2' size='small' />
                        <Typography category='subtitle' weight='bold' size='medium'>{info.title}</Typography>
                    </ItemTitleWrapper>
                    <ItemInfoWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small'>
                                Description
                            </Typography>
                            <Typography category='body' weight='regular' size='small' color='body'>
                                {info.description.slice(0, 10)}...
                            </Typography>
                        </ColumnWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small'>
                                Category
                            </Typography>
                            <Typography category='body' weight='regular' size='small' color='body'>
                                {info.category}
                            </Typography>
                        </ColumnWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small'>
                                Last Updated
                            </Typography>
                            <Typography category='body' weight='regular' size='small' color='body'>
                                {info.lastUpdated}
                            </Typography>
                        </ColumnWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small'>
                                Creation Date
                            </Typography>
                            <Typography category='body' weight='regular' size='small' color='body'>
                                {info.creationDate}
                            </Typography>
                        </ColumnWrapper>
                    </ItemInfoWrapper>
                </ItemLeftWrapper>
                <ItemActionsWrapper>
                    <Button size='small' type='secondary' icon='delete' pill={true} onClick={handleDelete} />
                    <Button size='small' type='secondary' icon='chevronRight' pill={true} onClick={handleOpen} />
                </ItemActionsWrapper>
            </ItemWrapper>
        </ItemListContainer>
    )
}

export default NoteItem;